import { DocumentNode, gql } from '@apollo/client'

export const ACTIVE_DAYCARE: DocumentNode = gql`
    mutation ActiveDaycare($daycare_id: Int!) {
        activeDaycare(daycare_id: $daycare_id)
    }
`

export const DEACTIVE_DAYCARE: DocumentNode = gql`
    mutation DeactiveDaycare($daycare_id: Int!) {
        deactiveDaycare(daycare_id: $daycare_id)
    }
`
